const AUTH_TOKEN_COOKIE = "auth_token";

/**
 * Resolves the API auth token for the current runtime.
 * - Server: reads API_AUTH_TOKEN from environment (Next.js server-only env).
 * - Client: reads the auth_token cookie set by your login flow.
 */
export function getAuthToken(): string | undefined {
  if (typeof window === "undefined") {
    return process.env.API_AUTH_TOKEN || undefined;
  }

  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${AUTH_TOKEN_COOKIE}=([^;]*)`),
  );

  if (!match?.[1]) {
    return undefined;
  }

  return decodeURIComponent(match[1]);
}
